const handleStatus = (description, status) => {
    let statuses = {
        'pending': 'Application Submitted for Review',
        'scoring': 'Application Submitted for Review',
        'approved': 'Application Accepted',
        'rejected': 'Application Rejected',
        'offer letter sent': 'Application Accepted: Offer Letter Sent',
        'offer accepted': 'Application Accepted: Offer Accepted',
        'offer rejected': 'Application Rejected: Offer Rejected',
        'documents requested': 'Application Accepted: Grant Documents Requested',
        'documents received': 'Application Accepted: Grant Documents Received',
        'claim approved for payment': 'Application Accepted: Claim Approved for Payment',
        'claim submitted for payment': 'Application Accepted: Claim Submitted for Payment',
        'claim processed': 'Application Accepted: Claim processed',
        'completed': 'Application Accepted: Completed',
    }

    const newStatus = statuses[status];

    return newStatus !== undefined ? description.replace(status, newStatus) : description;
}

export default function Card({ id, read = null, status, description , meta, link}) {
    return (
        <a href={link} className={`upcoming-grants__item ${read ? 'upcoming-grants__item--read' : ''}`}>
            <div className="upcoming-grants-item__text">
                <p>{ handleStatus(description, status) }</p>
                <p>{ id }</p>
            </div>
            <p className="upcoming-grants-item__author">{meta}</p>
        </a>
    )
}
